import enumeration, {TEnumerationValue} from '../../Shared/Util/enumeration';

const ActionType = enumeration(['UP', 'DOWN', 'LEFT', 'RIGHT', 'SELECT', 'FOCUS', 'BLUR', 'FOCUS_CHILD']);

type TActionType = TEnumerationValue<typeof ActionType>;

export {ActionType as default, type TActionType};
